import { Link } from "react-router-dom";
import { useArticles } from '../../hooks/useArticles';
import './BlogSection.css';

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const BlogSection = (props) => {
    const { limit = 6, showViewAll = true } = props;
    const { articles, loading, error } = useArticles(limit);

    if (loading) {
        return (
            <section className={"blog_section section-padding " + (props.tClass || '')}>
                <div className="container">
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading articles...</span>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (error) {
        return (
            <section className={"blog_section section-padding " + (props.tClass || '')}>
                <div className="container">
                    <div className="alert alert-danger" role="alert">
                        Error loading articles: {error}
                    </div>
                </div>
            </section>
        );
    }

    if (!articles || articles.length === 0) {
        return (
            <section className={"blog_section section-padding " + (props.tClass || '')}>
                <div className="container">
                    <div className="empty-state">
                        <div className="empty-state-icon">
                            <i className="flaticon-remedy"></i>
                        </div>
                        <h3 className="empty-state-title">No Articles Yet</h3>
                        <p className="empty-state-message">
                            We&apos;re currently preparing exciting medical insights and research articles.<br/>
                            Check back soon for expert perspectives on regenerative medicine.
                        </p>
                        <Link onClick={ClickHandler} to="/contact" className="empty-state-cta-btn">
                            Schedule a Consultation
                        </Link>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className={"blog_section section-padding " + (props.tClass || '')}>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="blog-section-header"
                        >
                            <h2 className="blog-section-title">
                                Medical Insights & Research
                            </h2>
                            <p className="blog-section-subtitle">
                                Expert perspectives on regenerative medicine and advanced treatments
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    {articles.map((article) => (
                        <div key={article.id} className="col-lg-4 col-md-6 col-12">
                            <div className="blog_card">
                                {article.featuredImage && (
                                    <div className="blog_image">
                                        <img
                                            src={article.featuredImage}
                                            alt={article.title}
                                        />
                                        {article.readTime && (
                                            <div className="blog_image_badges">
                                                <span className="blog_read_time_badge">
                                                    <i className="flaticon-deadline"></i>
                                                    {article.readTime.toString().includes('min') ? article.readTime : `${article.readTime} mins`}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                )}
                                <div className="blog_content">
                                    {article.category && article.category.length > 0 && (
                                        <div className="blog_categories_top">
                                            {(Array.isArray(article.category) ? article.category : [article.category]).map((cat, idx) => (
                                                <span key={idx} className="blog_category_tag">
                                                    {cat}
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                    <h3 className="blog_title">
                                        <Link onClick={ClickHandler} to={`/blog/${article.slug}`}>
                                            {article.title}
                                        </Link>
                                    </h3>
                                    {article.excerpt && (
                                        <p className="blog_excerpt">
                                            {article.excerpt.length > 120
                                                ? article.excerpt.substring(0, 120) + '...'
                                                : article.excerpt}
                                        </p>
                                    )}
                                    <div className="blog_footer">
                                        <Link
                                            onClick={ClickHandler}
                                            to={`/blog/${article.slug}`}
                                            className="blog_read_more"
                                        >
                                            Read More
                                            <i className="flaticon-right-arrow"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {showViewAll && articles.length >= limit && (
                    <div className="row">
                        <div className="col-12 text-center mt-4">
                            <Link onClick={ClickHandler} to="/blog" className="theme-btn">
                                View All Articles
                                <i className="flaticon-right-arrow"></i>
                            </Link>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}

export default BlogSection;



